// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"I_TheComp__5Xk_A"};